import { render, staticRenderFns } from "./Convocatoria.vue?vue&type=template&id=14ea2928&"
import script from "./Convocatoria.vue?vue&type=script&lang=js&"
export * from "./Convocatoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports